import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<import('modules/statistics/types').DealersStatisticsReducer>} */
const initialState = [];

/**
 * @param {Array<import('modules/statistics/types').DealersStatisticsReducer>} _
 * @param {import('modules/statistics/types').FetchDealersStatsSuccessAction} action
 * @returns {Array<import('modules/statistics/types').DealersStatisticsReducer>}
 */
const updateContent = (_, { payload }) => payload.content;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_DEALERS_SUCCESS]: updateContent,
});
